import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AddNewEmployee from "../pages/dashboardPage/emloyeeSettings/addNewEmployee/AddNewEmployee";
import AllEmployess from "../pages/dashboardPage/emloyeeSettings/allEmployess/AllEmployees";
import ControlHierarchy from "../pages/dashboardPage/emloyeeSettings/controlHierarchy/ControlHierarchy";
import EditEmployee from "../pages/dashboardPage/emloyeeSettings/editEmployee/EditEmployee";

// Tab id (permissionCatalog "employees") → its page.
const TAB_PAGES = {
  "all-employees": AllEmployess,
  "add-employee": AddNewEmployee,
  hierarchy: ControlHierarchy,
};

const EmployeeNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("employees", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {/* Not a tab: opened from the employee card's edit button. */}
      {rolePermissions.includes("update-admins") && (
        <Route path="/edit-employee" element={<EditEmployee />} />
      )}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default EmployeeNavigator;
